import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { MenuComponent } from './menu.component';
import { MenuSidebarComponent } from './menu-sidebar/menu-sidebar.component';
import { MenuService } from '../services/menu/menu.service';
import { AddToOrderComponent } from '../add-to-order/add-to-order.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckoutComponent } from '../checkout/checkout.component';
import { ItemModifierComponent } from '../add-to-order/item-modifier/item-modifier.component';



//Services
@NgModule({
  declarations: [
    MenuComponent,
    MenuSidebarComponent,
    AddToOrderComponent,
    CheckoutComponent,
    ItemModifierComponent
  ],
  exports: [
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    HttpModule,
    ReactiveFormsModule
  ],
  providers: [
    MenuService
  ]
})

export class MenuModule { }



// WEBPACK FOOTER //
// ./src/app/menu/menu.module.ts